import { Injectable } from '@angular/core';
import { downgradeToAJSService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { ISpecialMealsSegment, MENU_TYPE, MenuSelected } from '../models/special-meals.model';


@Injectable()
export class IbSpecialMealsService {

    constructor(
        private localStorageService: CommonsSessionStorageService
    ) {

    }

    getMenusSelected(totalPassengers: number, specialMealsSegment: ISpecialMealsSegment[]): MenuSelected[] {
        const segmentsAvailable = specialMealsSegment.filter(segment => segment.status.code === 'AVAILABLE');
        let specialMeals = [];
        segmentsAvailable.forEach(segment => specialMeals = [...specialMeals, ...this.getSpecialMealsData(segment.id)]);
        const totalSpecialMeals = specialMeals.reduce((accumulator, meal) => (meal.menu !== 'standard' ? accumulator + 1 : accumulator), 0);
        const totalStandardMenu = (totalPassengers * segmentsAvailable.length) - totalSpecialMeals;
        return [
            this.getMenuSelectedModel(totalStandardMenu, MENU_TYPE.STANDARD),
            this.getMenuSelectedModel(totalSpecialMeals, MENU_TYPE.SPECIAL_MEALS)
        ]
    }

    getMenusBySegment(segmentId: string): MenuSelected[] {
        const specialMeals = this.getSpecialMealsData(segmentId);
        const mealsBySegment = specialMeals.filter(meal => meal.segmentId === segmentId);
        const totalSpecialMeals = mealsBySegment.reduce((accumulator, meal) => (meal.menu !== 'standard' ? accumulator + 1 : accumulator), 0);
        const totalStandardMenu = mealsBySegment.reduce((accumulator, meal) => (meal.menu === 'standard' ? accumulator + 1 : accumulator), 0);
        return [
            this.getMenuSelectedModel(totalStandardMenu, MENU_TYPE.STANDARD),
            this.getMenuSelectedModel(totalSpecialMeals, MENU_TYPE.SPECIAL_MEALS)
        ];

    }

    private getSpecialMealsData(segmentId: string) {
        const specialMealsTempInfoAux = this.localStorageService.get('specialMealsTempInfoAux') as any[];
        const specialMealsCopy = this.localStorageService.get('specialMealsCopy') as any[];
        const specialMealsInfo = specialMealsTempInfoAux ? specialMealsTempInfoAux : specialMealsCopy;
        return specialMealsInfo.filter(sm => sm.segmentId === segmentId);
    }

    private getMenuSelectedModel(total: number, type: MENU_TYPE): MenuSelected {
        return {
            total, type,
            labels: {
                singular: type === MENU_TYPE.SPECIAL_MEALS ? 'MMB_CUSTOMIZE_FLIGHTS_SPECIAL_MEALS_LABEL_NUM_SELECTED_SINGLE' : 'MMB_CUSTOMIZE_FLIGHTS_STANDAR_MEALS_LABEL_NUM_SELECTED',
                plural: type === MENU_TYPE.SPECIAL_MEALS ? 'MMB_CUSTOMIZE_FLIGHTS_SPECIAL_MEALS_LABEL_NUM_SELECTED_PLURAL' : 'MMB_CUSTOMIZE_FLIGHTS_STANDAR_MEALS_LABEL_NUM_SELECTED',
            }
        }
    }
}
downgradeToAJSService(
    'IbSpecialMealsService',
    IbSpecialMealsService,
    'ib-MmB-gastronomic-proposal-module'
);
